import { Pipe, PipeTransform } from '@angular/core';
import { DateService } from '../services/date.service';

@Pipe({
    name: 'ageFormat',
    standalone: false
})
export class AgePipe implements PipeTransform {
  constructor(private dateService: DateService) {
  }

  transform(
    value: string,
  ): number {
    const dataNascimento = new Date(value);
    const hoje = new Date();
    const anoAtual = hoje.getFullYear();
    const mesAtual = hoje.getMonth() + 1;
    const diaAtual = hoje.getDate();

    const anoNascimento = dataNascimento.getFullYear();
    const mesNascimento = dataNascimento.getMonth() + 1;
    const diaNascimento = dataNascimento.getDate();

    let idade = anoAtual - anoNascimento;

    // Verifica se já fez aniversário neste ano
    if (mesAtual < mesNascimento || (mesAtual === mesNascimento && diaAtual < diaNascimento)) {
      idade--;
    }

    return idade;
  }
}
